import React, { useState } from 'react'
import Modal from 'react-modal'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
}

// Modal.setAppElement(document.getElementById("root"))

export default ({ isOpen, onAfterOpen, onRequestClose, contentLabel, title, body, footer, styles, disableClose }:
    { isOpen: any, onAfterOpen: any, onRequestClose: any, contentLabel: any, title: any, body: any, footer: any, styles: any, disableClose: any }
) => {
    const [open, setOpen] = useState(isOpen)



    const _closeModal = () => {
        if (disableClose) return;
        setOpen(false)
    }

    return (
        <Modal
            isOpen={open}
            onAfterOpen={onAfterOpen || function noRefCheck() { }}
            contentLabel={contentLabel}
            style={styles || customStyles}
            className="jsmodal-dialog-transparent"
            shouldCloseOnOverlayClick={!disableClose}
            onRequestClose={onRequestClose || _closeModal}
        >
            <div className='jsmodal-content'>
                <div className='jsmodal-body'>{body}</div>
            </div>
        </Modal>
    )
}